import styled from 'styled-components';

export const ModalTitle = styled.div`
  color: ${({ theme }) => theme.colors.black9};
  font-size: 24px;
  font-weight: 600;
  line-height: 32px;
  display: flex;
  padding: 16px 16px 12px 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  align-self: stretch;

  @media (min-width: ${({ theme }) => theme.mediaQueries.md}) {
    font-size: 30px;
    line-height: 40px;
    padding: 16px 16px 12px 16px;
  }
`;

export const ModalSubtitle = styled.div`
  color: ${({ theme }) => theme.colors.black9};
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
`;

export const ModalDescription = styled.div`
  color: ${({ theme }) => theme.colors.black10};

  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
`;

export const RedText = styled.span`
  color: ${({ theme }) => theme.colors.red6};
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
`;

export const ModalWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;

  @media (min-width: ${({ theme }) => theme.mediaQueries.md}) {
    gap: 24px;
  }
`;

export const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;

  @media (min-width: ${({ theme }) => theme.mediaQueries.md}) {
    gap: 32px;
  }
`;

export const FieldLabel = styled.div`
  color: ${({ theme }) => theme.colors.black9};
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  margin-bottom: 4px;
  .required {
    color: ${({ theme }) => theme.colors.red6};
    margin-right: 4px;
  }
`;
export const SectionTitle = styled.div`
  color: ${({ theme }) => theme.colors.black9};
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: -0.2px;
  margin-bottom: 16px;
  margin-top: 8px;

  &:first-child {
    margin-top: 0;
  }
`;
